export enum QuickPaymentCategory {
  PAYMENT = 'Payment',
  EXPENSE = 'Expense'
}
